import once from 'lodash/once'

/**
 * Loads Intercom. We can't put this as a script tag, otherwise
 * Intercom will complain because we don't have an app ID configured.
 */
export const loadIntercom = once(function loadIntercom() {
  /* eslint-disable */
  const w = window as any
  const ic = w.Intercom
  if (typeof ic === 'function') {
    ic('reattach_activator')
    ic('update', w.intercomSettings)
  } else {
    const d = document
    var i = function () {
      i.c(arguments)
    } as any
    i.q = []
    i.c = function (args: any[]) {
      i.q.push(args)
    }
    w.Intercom = i
    const s = d.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.src = 'https://js.intercomcdn.com/shim.latest.js'
    const x = d.getElementsByTagName('script')[0] as any
    x.parentNode.insertBefore(s, x)
  }
})
